<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex class="text-center">
        <h1 class="header">
          Benvenuto in
          <img
            v-if="config.host == 'egyn'"
            class="header-logo"
            src="../assets/egyn-white.svg"
          />
          <img
            v-if="config.host == 'ebiology'"
            class="header-logo"
            src="../assets/ebiology-white.svg"
          />
        </h1>

        <h2 v-if="config.host == 'egyn'" class="sub-header">
          Il 1° creatore di siti web per la Ginecologia specialistica
        </h2>
        <h2 v-if="config.host == 'ebiology'" class="sub-header">
          Il 1° creatore di siti web per i Biologi Nutrizionisti
        </h2>
        <div>
          <h3 class="text-title">
            Per accedere è necessario essere registrati
          </h3>

          <h4>
            Per registrarsi basta seguire
            <router-link class="link" to="/wizard">il link</router-link> alla
            pagina di registrazione
          </h4>

          <ValidationObserver ref="obs" v-slot="{ invalid, validated }">
            <v-form class="login_form" @submit="login()">
              <ValidationProvider
                rules="required|email"
                v-slot="{ errors, valid }"
              >
                <v-row class="text-center" align="center" justify="center">
                  <v-col>
                    <v-text-field
                      outlined
                      autocomplete="email"
                      color="secondary"
                      v-model="email"
                      prepend-icon="mdi-email"
                      :error-messages="errors"
                      :success="valid"
                      required
                      :disabled="logging"
                      label="E-mail"
                    />
                  </v-col>
                </v-row>
              </ValidationProvider>

              <ValidationProvider rules="required" v-slot="{ errors, valid }">
                <v-row class="text-center" align="center" justify="center">
                  <v-col>
                    <v-text-field
                      outlined
                      autocomplete="password"
                      color="secondary"
                      v-model="password"
                      prepend-icon="mdi-lock-outline"
                      :append-icon="password_view ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="() => (password_view = !password_view)"
                      :type="password_view ? 'password' : 'text'"
                      :error-messages="errors"
                      :success="valid"
                      required
                      :disabled="logging"
                      label="Password"
                    />
                  </v-col>
                </v-row>
              </ValidationProvider>

              <v-row class="text-center" align="center" justify="center" dense>
                <v-col>
                  <v-btn
                    type="submit"
                    :disabled="invalid || !validated"
                    @click="login()"
                    v-if="!logging"
                    color="#b083a8"
                    class="white--text"
                    >LOGIN</v-btn
                  >

                  <v-progress-circular
                    v-if="logging"
                    :indeterminate="true"
                    :rotate="0"
                    :size="32"
                    :width="4"
                    color="light-blue"
                  ></v-progress-circular>
                </v-col>
              </v-row>
              <v-row class="text-center" dense>
                <v-col>
                  <v-alert
                    v-if="loginError"
                    type="error"
                    dense
                    dark
                    dismissible
                  >
                    <span v-text="loginError" />
                  </v-alert>
                </v-col>
              </v-row>
              <v-row class="text-center" align="center" justify="center">
                <v-col>
                  <router-link
                    v-if="!logging"
                    class="lost-password"
                    to="/recovery"
                    >Password dimenticata ?</router-link
                  >
                </v-col>
              </v-row>
              <div style="height:70px" />
            </v-form>
          </ValidationObserver>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style scoped>
.header {
  background-color: #213b52;
  color: white;
  font-weight: 400;
}
.sub-header {
  color: #999999;
  background-color: #74a2bc;
  color: white;
}

.text-title {
  color: #74a2bc;
  font-size: 30px;
}

.form-title {
  color: gray;
  font-size: 20px;
  margin: 10px;
}

.lost-password {
  color: red;
  font-size: 20px;
  margin: 10px;
}

.link {
  color: red;
}

.header-logo {
  height: 40px;
}

.login_form {
  max-width: 600px;
  margin: auto;
}
</style>


<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import config from "../config/index";

export default {
  data() {
    return {
      logging: false,
      email: "",
      password: "",
      loginError: "",
      password_view: String,
      config: config,
    };
  },

  mounted() {
    this.logging = false;
    this.$refs.obs.reset();
  },

  components: {
    ValidationProvider,
    ValidationObserver,
  },

  methods: {
    login: function() {
      let email = this.email;
      let password = this.password;
      this.loginError = "";
      this.logging = true;
      this.$store
        .dispatch("login", { email, password })
        .then(() => {
          if (this.$store.state.user.step) {
            this.$router.push("/wizard");
          } else if (this.$store.state.user.sites_count) {
            this.$router.push("/");
          } else {
            this.$router.push("/wizard");
          }
        })
        .catch((err) => {
          this.loginError = err;
          this.logging = false;
        });
    },
  },
};
</script>
